import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';

export const serviceProviderStatsApiSlice = createApi({
  reducerPath: 'serviceProviderStatsApiSlice',
  baseQuery,
  endpoints: (builder) => ({
    getCustomerSuccessStats: builder.query({
      query: ({ apiManager, ...params }) => apiManager.getCustomerSuccessStats(params),
    }),
    getOnboardingStats: builder.query({
      query: ({ apiManager, ...params }) => apiManager.getOnboardingStats(params),
    }),
    getSalesTeamStats: builder.query({
      query: ({ apiManager, ...params }) => apiManager.getSalesTeamStats(params),
    }),
  }),
});

export const { useGetCustomerSuccessStatsQuery, useGetOnboardingStatsQuery, useGetSalesTeamStatsQuery } =
  serviceProviderStatsApiSlice;
